import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `SheetDirective` represent a sheet of the React Spreadsheet.
 * It must be contained in a Spreadsheet component(`SpreadsheetComponent`).
 * ```tsx
 * <SpreadsheetComponent>
 *   <SheetsDirective>
 *    <SheetDirective></SheetDirective>
 *    <SheetDirective></SheetDirective>
 *   </SheetsDirective>
 * </SpreadsheetComponent>
 * ```
 */
export class SheetDirective extends ComplexBase {
}
SheetDirective.moduleName = 'sheet';
export class SheetsDirective extends ComplexBase {
}
SheetsDirective.propertyName = 'sheets';
SheetsDirective.moduleName = 'sheets';
